import React from "react";
import "./LinkTree.css";

const FavoriteOS = () => {
  return (
    <div
      className="neofetch-container"
      style={{
        fontFamily: "monospace",
        backgroundColor: "black",
        color: "lime",
        padding: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
      }}
      onClick={() => window.open("https://regolith-linux.org/", "_blank")}
    >
      <div
        className="info-section"
        style={{
          width: "540px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundImage: "url('/regolith-logo.avif')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "10px",
        }}
      >
        <div
          className="info-section"
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "rgba(0,0,0,0.7)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <h1
            style={{
              margin: "0 0 10px 0",
              color: "lime",
              fontSize: "1.5em",
            }}
          >
            Regolith
          </h1>

          <div
            className="system-info"
            style={{
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            <p>OS: Regolith Linux</p>
            <p>Kernel: Linux 5.15.0-75</p>
            <p>Shell: bash 5.1.16</p>
            <p>Resolution: 1920x1080</p>
            <p>DE: i3-gaps</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FavoriteOS;
